import React from "react";
import PropTypes from "prop-types";
import "./HeroSection.css";

function HeroSection({ title, subtitle, backgroundImage }) {
  return (
    <section 
      className="hero-section"
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}}
    >
      <div className="hero-section-content">
        <h1 className="hero-section-title">{title}</h1>
        <p className="hero-section-subtitle">{subtitle}</p>
      </div>
    </section>
  );
}

HeroSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string,
};

export default HeroSection;
